<template>
  <SogPage title="Passwort Änderung">
    <SogCard>
      <SogCardContent>
        <PasswordChangeForm
          ref="_form"
          :data="_gdvAccess"
        />
      </SogCardContent>
      <SogCardActions>
        <SogCardActionButton
          :kind="SogButtonKind.Save"
          @click="onSave"
        >
          Speichern
        </SogCardActionButton>
        <SogCardActionButton
          :kind="SogButtonKind.Cancel"
          @click="OnCancel"
        >
          Abbrechen
        </SogCardActionButton>
      </SogCardActions>
    </SogCard>
  </SogPage>
</template>

<script setup lang="ts">
import SogPage from "@/shared/ui/SogPage.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import PasswordChangeForm from "@/modules/Gdv/components/PasswordChangeForm.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import {SogButtonKind} from "@/shared/ui/types/SogButtonKind";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import {useRouter} from "vue-router";
import apiGdv from "@/modules/Gdv/api";
import {onMounted, reactive, ref} from "vue";
import {useGdvStore} from "@/modules/Gdv/store";
import GdvAccess from "@/shared/model/GdvAccess";
import {useSpinner} from "@/shared/composables/SogSpinner";
import {useNavigationStore} from "@/modules/Navigation/store";
import copyTo from "@/shared/utils/CopyTo";
import notificationService from "@/shared/services/NotificationService";

const _router = useRouter();
const _form = ref<InstanceType<typeof PasswordChangeForm> | null>()
const _gdvStore = useGdvStore();
const _gdvAccess = reactive<GdvAccess>(new GdvAccess())
const _spinner = useSpinner();
const _navigationStore = useNavigationStore();

async function p_init() {
  if (!_navigationStore.currentGdvAccessId || !_gdvStore.gdvAccess || _navigationStore.currentGdvAccessId !== _gdvStore.gdvAccess.id) {
    _router.back()
    return;
  }
  try {
    _spinner.show()
    {
//      copyTo(_clipboardStore.gdvaccess, _gdvAccess.value)
      copyTo(_gdvStore.gdvAccess, _gdvAccess)
    }
  } finally {
    _spinner.hide()
  }
}


//_gdvAccess.value  _clipboardStore.gdvaccess;
onMounted(async () => {

  await p_init()
  //console.log(_gdvAccess)

})

function OnCancel() {
  return _router.back();
}

async function onSave() {
  if (_form.value && _form.value.validate()) {
    const result = _form.value.getPassword();
    const res = await apiGdv.changePassword(_gdvAccess.id, result)
    if (res) {
      notificationService.success(res)
      _router.back()
    }
    return
  }
}
</script>

<style scoped>

</style>
